var exports = {
  "O": "x620889e6--9b9e57--placement-application-button",
};

module.exports = exports;
